import React, { useState } from "react";
import "./Discussion.css";

function Discussion() {
  const [comments, setComments] = useState([
    {
      user: "Alice",
      text: "What are the key themes in Modernist literature?",
      time: "1 hour ago",
      replies: [
        { user: "Eve", text: "One theme is the fragmentation of identity.", time: "30 minutes ago" },
      ],
    },
    {
      user: "Bob",
      text: "I believe Modernist works focus on disillusionment and breaking traditional forms.",
      time: "30 minutes ago",
      replies: [],
    },
  ]);

  const [newComment, setNewComment] = useState("");
  const [replyText, setReplyText] = useState({});
  const [showReplies, setShowReplies] = useState({});

  const handleAddComment = () => {
    if (newComment.trim()) {
      setComments([...comments, { user: "You", text: newComment, time: "Just now", replies: [] }]);
      setNewComment("");
    }
  };

  const handleAddReply = (index) => {
    if (replyText[index]?.trim()) {
      const updatedComments = [...comments];
      updatedComments[index].replies.push({
        user: "You",
        text: replyText[index],
        time: "Just now",
      });
      setComments(updatedComments);
      setReplyText({ ...replyText, [index]: "" });
    }
  };

  const toggleReplies = (index) => {
    setShowReplies({ ...showReplies, [index]: !showReplies[index] });
  };

  return (
    <div className="discussion-container">
      <div className="comments-section">
        {comments.map((comment, index) => (
          <div key={index} className="comment">
            <strong>{comment.user}</strong>
            <p>{comment.text}</p>
            <span>{comment.time}</span>

            {/* Toggle Replies Visibility */}
            {comment.replies.length > 0 && (
              <button
                className="toggle-replies"
                onClick={() => toggleReplies(index)}
              >
                {showReplies[index]
                  ? `Hide Replies (${comment.replies.length})`
                  : `View Replies (${comment.replies.length})`}
              </button>
            )}

            {/* Replies */}
            {showReplies[index] && (
              <div className="replies">
                {comment.replies.map((reply, replyIndex) => (
                  <div key={replyIndex} className="reply">
                    <strong>{reply.user}</strong>
                    <p>{reply.text}</p>
                    <span>{reply.time}</span>
                  </div>
                ))}
              </div>
            )}

            {/* Reply Input */}
            <div className="add-reply">
              <input
                type="text"
                placeholder="Write a reply..."
                value={replyText[index] || ""}
                onChange={(e) => setReplyText({ ...replyText, [index]: e.target.value })}
              />
              <button onClick={() => handleAddReply(index)}>Reply</button>
            </div>
          </div>
        ))}
      </div>

      {/* Add New Comment */}
      <div className="add-comment">
        <input
          type="text"
          placeholder="Add your comment..."
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
        />
        <button onClick={handleAddComment}>Submit</button>
      </div>
    </div>
  );
}

export default Discussion;
